<template lang="html">
  <section class="all-results">
    <div v-if="noResults" class="no-results">לא נמצאו תוצאות</div>
    <div class="row mx-n2" :class="{'invisible h-0':loading !== 'Complete'}">
      <div class="col-md-6 px-2" :class="{'d-none':commonCount < 1}">
        <div class="frame-area bg-white" >
          <div class="results-heading d-flex justify-content-between align-items-center px-2">
            <div>{{searchModel === 'rhyme' ? 'חרוזים נפוצים' : 'מילים נפוצות'}}</div>
            <small><span v-if="commonMore">+</span>{{commonCount}} תוצאות</small>
          </div>
          <ResultsList :list="'common'" @commonResults="updateCommonCount('countItems', ...arguments)"/>
          <small class="more text-primary position-absolute" @click="switchView('Common')">
            {{hebrew ? 'הצג עוד' : 'Show more'}}
          </small>
        </div>
      </div>       

      <div class="col-md-6 px-2" :class="{'d-none':bibleResultsCount < 1}">
        <div class="frame-area bg-white">
          <div class="results-heading d-flex justify-content-between align-items-center px-2">
            <div>{{searchModel === 'rhyme' ? 'חרוזים מהתנ״ך' : 'מילים מהתנ״ך'}}</div>
            <small><span v-if="bibleMore">+</span>{{bibleResultsCount}} תוצאות</small>
          </div>
          <BibleResultsList @biblicalResults="updateBiblicalCount('countItems', ...arguments)"></BibleResultsList>
          <small class="more text-primary position-absolute" @click="switchView('Bible')">
            {{hebrew ? 'הצג עוד' : 'Show more'}}
          </small>
        </div>
      </div>

      <div class="col-md-6 px-2" :class="{'d-none':rhymeResultsCount < 1}">
        <div class="frame-area bg-white" >
          <div class="results-heading d-flex justify-content-between align-items-center px-2">
            <div>הרשימה המלאה</div>
            <small><span v-if="rhymeMore">+</span>{{rhymeResultsCount}} תוצאות</small>
          </div>            
          <ResultsList :list="'general'" @results="updateCount('countItems', ...arguments)"/>
          <small class="more text-primary position-absolute" @click="switchView('Default')">
            {{hebrew ? 'הצג עוד' : 'Show more'}}
          </small>
        </div>
      </div>         

      <div class="col-md-6 px-2" :class="{'d-none':nsCount < 1}">
        <div class="frame-area bg-white" >
          <div class="results-heading d-flex justify-content-between align-items-center px-2">
            <div>{{searchModel === 'rhyme' ? 'חרוזים ללא סיומת' : 'מילים ללא סיומת'}}</div>
            <small><span v-if="nsMore">+</span>{{nsCount}} תוצאות</small>
          </div>            
          <ResultsList :list="'ns'" @nsResults="updateNsCount('countItems', ...arguments)"/>
          <small class="more text-primary position-absolute" @click="switchView('NS')">
            {{hebrew ? 'הצג עוד' : 'Show more'}}
          </small>
      </div>
    </div>        

    <div class="col-md-6 px-2" :class="{'d-none':longCount < 1}">
      <div class="frame-area bg-white" >
        <div class="results-heading d-flex justify-content-between align-items-center px-2">
          <div>{{searchModel === 'rhyme' ? 'חרוזים ארוכים' : 'מילים ארוכות'}}</div>
          <small><span v-if="longMore">+</span>{{longCount}} תוצאות</small>
        </div>
        <ResultsList :list="'long'" @longResults="updateLongCount('countItems', ...arguments)"/>
        <small class="more text-primary position-absolute" @click="switchView('Long')">
          {{hebrew ? 'הצג עוד' : 'Show more'}}
        </small>
      </div>
    </div>

    <div class="col-md-6 px-2"  :class="{'d-none':femCount < 1}">
      <div class="frame-area bg-white" >
        <div class="results-heading d-flex justify-content-between align-items-center px-2">
          <div>{{searchModel === 'rhyme' ? 'חרוזים בלשון נקבה' : 'מילים בלשון נקבה'}}</div>
          <small><span v-if="femMore">+</span>{{femCount}} תוצאות</small>
        </div>
        <ResultsList :list="'fem'" @femResults="updateFemCount('countItems', ...arguments)"/>
        <small class="more text-primary position-absolute" @click="switchView('Fem')">
          {{hebrew ? 'הצג עוד' : 'Show more'}}
        </small>
      </div>
    </div>               

    </div>    
  </section>
</template>
<script lang="js">
  function gtag() { window.dataLayer.push(arguments) }
  import BibleResultsList from '@/components/BibleResultsList'
  import ResultsList from '@/components/ResultsList'
  export default  {
    name: 'AllResults',
    components: {BibleResultsList, ResultsList},
    props: [],
    data() {
      return {
        rhymeResultsCount: 0,
        bibleResultsCount: 0,
        commonCount: 0,
        nsCount: 0,
        longCount: 0,
        femCount: 0,
        rhymeMore: false,
        bibleMore: false,
        commonMore: false,
        femMore: false,
        nsMore: false,
        longMore: false,
        metaDesc: 'כלי החרוזית מאתר חרוזים, מצלול, אליטרציה ותבנית מילה על בסיס מילת חיפוש. ניתן לסנן את תוצאות החיפוש על ידי הזנת מילים משדה סמנטי מסויים ומאפינים דיקדוקיים.',
        emptyResults: false
      }
    },    
    methods: {
      updateCount (countItems, value, fMore) {
        this.rhymeResultsCount = value
        this.rhymeMore = fMore
      },
      updateBiblicalCount (countItems, value, fMore) { 
        this.bibleResultsCount = value
        this.bibleMore = fMore
      },
      updateCommonCount (countItems, value, fMore, topTenResults) { 
        this.commonCount = value
        this.commonMore = fMore
        if (this.loading === 'Complete') {
          var desc = 'חרוזים למילה ' + this.searchWord + ': ' + topTenResults + ' ועוד... '
          desc += this.metaDesc
          document.querySelector('meta[name="description"]').setAttribute("content", desc)
        }        
      },
      updateNsCount (countItems, value, fMore) { 
        this.nsCount = value
        this.nsMore = fMore
      },
      updateLongCount (countItems, value, fMore) { 
        this.longCount = value
        this.longMore = fMore
      },
      updateFemCount (countItems, value, fMore) { 
        if (value == 0 && this.longCount == 0 && this.nsCount == 0 
        && this.bibleResultsCount == 0 && this.commonCount == 0 && this.rhymeResultsCount == 0 && this.loading === 'Complete') {
          this.emptyResults = true
          this.$emit('rhymeResultsCount', 0)
        } else {
          this.emptyResults = false
          this.$emit('rhymeResultsCount', 1)
        }
        this.femCount = value
        this.femMore = fMore
      },
      switchView (view) {
        gtag('event', 'View more clicked', {
          'event_category': 'selection',
          'event_label': view
        })
        this.$store.commit('SET_VIEW_MODE', view)        
        this.$store.commit('SET_OVERVIEW', false)
        this.$store.state.displayDefault = false
        this.$store.state.displayCommon = false
        this.$store.state.displayBible = false
        this.$store.state.displayNS = false
        this.$store.state.displayNS = false
        this.$store.state.displayFem = false
        this.$store.state.displayLong = false
        switch (view) {          
          case 'Default': 
            this.$store.state.displayDefault = true
            break;
          case 'Common':
            this.$store.state.displayCommon = true
            break;
          case 'Bible':
            this.$store.state.displayBible = true
            break;
          case 'NS':
            this.$store.state.displayNS = true
            break;
          case 'Fem':
            this.$store.state.displayFem = true
            break;
          case 'Long': 
            this.$store.state.displayLong = true
            break;   
        }
      }                
    },
    computed: {
      searchWord: function () {
        return this.$store.state.textForCharuzitApiCall
      },
      loading: function() {
        return this.$store.state.charuzitApiState
      },
      noResults: function() {
        return this.$store.state.noResults || this.emptyResults
      },
      searchModel: function() {
        return this.$store.state.searchModel
      },
      hebrew () {
        return this.$settings.hebrew
      }
    }
  }
</script>
<style scoped lang="scss">
    .invisible {
      overflow: hidden;
    }
    .col-md-6{
      margin-bottom: 25px;
    }
  </style>
  <style lang="scss"> 
    .col-md-6 .frame-area {
      border-radius: 6px;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
      height: 435px;
      overflow: auto;
      @media (max-width: 991px) {
        height: auto;
        padding-bottom: 40px;
      }
      .results-heading  {
          height: 36px;
          background: #d6ecff;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
      }
      li {
          font-size: 20px;
          p {
            padding: 1px 0 5px;
          }
      }
      .more {
          cursor: pointer;
          bottom: 10px;
          margin: 0 10px;
          text-decoration: underline;
      }
     .result-list-wrap {
        height: 85%;
        overflow-y: auto;
      }
    }
</style>
